import React from "react";
import { Tabel } from "../core";
import { useDispatch, useSelector } from "react-redux";
import { getSendYarn } from "../redux/Action/Sizer/sendYarn";
import { getCompanyId } from "../helper/utils/companyId";

const columns = [
  {
    title: "Quality",
    dataIndex: "yarn_quality_id",
    render: function (text, record, index) {
      return (
        <span>
          {record.count}/{record.con_size}/{record.brand}/{record.type}
        </span>
      );
    },
    width: 150,
  },
  {
    title: "Quantity",
    dataIndex: "quantity",
    render: function (text, record, index) {
      return (
        <span>
          {record.bags_send_yarn}/ {record.cons_send_yarn}
        </span>
      );
    },

    width: "150px",
  },
];

const SendYarnHistory = ({ sizerId }) => {
  console.log(sizerId);
  const sendYarnHistopry = useSelector((state) => state.sendYarn.sendyarn);
  const { token } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const company_id = getCompanyId();
  React.useEffect(() => {
    async function getData() {
      await dispatch(getSendYarn(company_id, sizerId, token));
    }
    getData();
  }, [sizerId, dispatch, company_id, token]);

  return (
    <Tabel
      padding="0px"
      nowidth={false}
      columns={columns}
      data={sendYarnHistopry}
    />
  );
};

export default SendYarnHistory;
